/* eslint-env browser, jquery */

'use strict';

const { setShellEventOrRun } = require('@grpn/shell-page');

require('../vendor/backbone');

const jsInitializer = require('../initializers/js_initializer');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

setShellEventOrRun(() =>
  jsInitializer.addJsFiles(critModules, nonCritModules, pageReadyModules)
);
